














import { IResPest } from "@/api/diseasePest";
import { defineComponent, PropType } from "@vue/composition-api";
export default defineComponent({
  name: "PestCard",
  props: {
    info: {
      type: Object as PropType<IResPest>,
      default: () => ({}),
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    return {
      handleClick: () => {
        emit("click", props.info.id);
      },
    };
  },
});
